/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown> }} Partner_Customer_Contract_Ended_NoticeInputs */



/**
* | output |
* | --- |
* | "The contract ended on {date}. This is now an ordinary Team customer, billed monthly, and its plan and add-ons can be changed again." |
*
* @param {Partner_Customer_Contract_Ended_NoticeInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_customer_contract_ended_notice = /** @type {((inputs: Partner_Customer_Contract_Ended_NoticeInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Customer_Contract_Ended_NoticeInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Der Vertrag endete am ${i?.date}. Dies ist jetzt ein regulärer Team-Kunde mit monatlicher Abrechnung; Tarif und Zusatzmodule können wieder geändert werden.`)
	return /** @type {LocalizedString} */ (`The contract ended on ${i?.date}. This is now an ordinary Team customer, billed monthly, and its plan and add-ons can be changed again.`)
});